




exports.default =
  props: ['to', 'name']

  methods:
    back: ->
      if @to
        @$router.go(@to)
      else
        window.history.back()




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/back_link.vue